/* tslint:disable */
export const APP_VERSION = 'local development';
/* tslint:enable */
